(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec789"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec789"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dxEC4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dbddc5847e39269$export$71511d61b312f219; });
function $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dbddc5847e39269$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dbddc5847e39269$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("gh3Df", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd910d1ee9896911$export$71511d61b312f219; });
function $bd910d1ee9896911$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

var $4fc5830bf026ae9f$export$e1252723db1c541 = {
    player: '.episode-player',
    stickyPlayer: '.sticky-episode-player',
    audio: 'audio',
    firstAudio: 'audio:first-of-type',
    audioFull: 'audio[data-version="full"]',
    audioShort: 'audio[data-version="short"]',
    playlist: '.episode-player__playlist',
    playlistEpisode: '.episode',
    playlistEpisodeDuration: '.episode__duration',
    playlistActiveEpisode: '.episode.selected',
    btnPlayPause: 'button.playpause',
    btnSkipBackward: 'button.skip-backward',
    btnSkipForward: 'button.skip-forward',
    timeCurrent: '.time__current',
    timeTotal: '.time__total',
    progressBar: '.seek-slider',
    externalControl: '.episode-external-control',
    externalControlPlayBtn: '.episode-external-control__playpause',
    externalControlCloseBtn: 'button.close',
    externalControlDuration: '.duration'
};
var $4fc5830bf026ae9f$export$ce4ab0c55987d1ff = {
    episodeActive: 'selected',
    showStickyPlayer: 'show'
};
var $4fc5830bf026ae9f$export$2f3da36212191bc6 = 10;


var $c46e17639d9bdc7d$export$9eabacebe6624782 = function(secs) {
    var minutes = Math.floor(secs / 60);
    var seconds = Math.floor(secs % 60);
    var returnedSeconds = seconds < 10 ? "0".concat(seconds) : "".concat(seconds);
    return "".concat(minutes, ":").concat(returnedSeconds);
};
var $c46e17639d9bdc7d$export$4a79f0068700788b = function(secs) {
    return Math.floor(secs / 60);
};


var $234e243fa0798158$export$e74726c334bb9cd0 = function(player) {
    var _window;
    var playerEpisodeID = player.getAttribute('data-episode-id');
    var externalControl = document.querySelector("".concat((0, $4fc5830bf026ae9f$export$e1252723db1c541).externalControl, '[data-episode-id="').concat(playerEpisodeID, '"]'));
    var stickyPlayer = document.querySelector("".concat((0, $4fc5830bf026ae9f$export$e1252723db1c541).stickyPlayer, '[data-episode-id="').concat(playerEpisodeID, '"]'));
    if (!externalControl || !stickyPlayer) return;
    var playerData = (_window = window) === null || _window === void 0 ? void 0 : _window.itdAudioPlayers["episode-".concat(playerEpisodeID)];
    // Show duration.
    var showDuration = function() {
        externalControl.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).externalControlDuration).textContent = "".concat((0, $c46e17639d9bdc7d$export$4a79f0068700788b)(playerData.audioEl.duration), " min");
    };
    if (playerData.audioEl.readyState > 0) showDuration();
    else playerData.audioEl.addEventListener('loadedmetadata', showDuration);
    // Handle click events on play buttons
    var playButtons = externalControl.querySelectorAll((0, $4fc5830bf026ae9f$export$e1252723db1c541).externalControlPlayBtn);
    playButtons.forEach(function(playBtn) {
        playBtn.addEventListener('click', function() {
            var _window;
            if (externalControl.getAttribute('data-play-state') === 'play') {
                closePlayer();
                return;
            }
            /**
			 * 1. Reset other players
			 */ // Reset external control play state.
            document.querySelectorAll((0, $4fc5830bf026ae9f$export$e1252723db1c541).externalControl).forEach(function(control) {
                control.setAttribute('data-play-state', 'pause');
            });
            // Hide players.
            var stickyPlayers = document.querySelectorAll((0, $4fc5830bf026ae9f$export$e1252723db1c541).stickyPlayer);
            stickyPlayers.forEach(function(player) {
                return player.classList.remove((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).showStickyPlayer);
            });
            // Pause.
            if ((_window = window) === null || _window === void 0 ? void 0 : _window.itdAudioPlayers) Object.values(window.itdAudioPlayers).forEach(function(player) {
                return player.stop();
            });
            /**
			 * 2. Start clicked player
			 */ if (playerData) {
                // Update external control state.
                externalControl.setAttribute('data-play-state', 'play');
                // Show player.
                stickyPlayer.classList.add((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).showStickyPlayer);
                // Play.
                playerData.play();
            }
        });
    });
    var closePlayer = function() {
        stickyPlayer.classList.remove((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).showStickyPlayer);
        externalControl.setAttribute('data-play-state', 'pause');
        window.itdAudioPlayers["episode-".concat(playerEpisodeID)].stop();
    };
    // Handle click events on close button
    var playerCloseBtn = stickyPlayer.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).externalControlCloseBtn);
    playerCloseBtn === null || playerCloseBtn === void 0 ? void 0 : playerCloseBtn.addEventListener('click', closePlayer);
};




var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");


var $dxEC4 = parcelRequire("dxEC4");

var $gh3Df = parcelRequire("gh3Df");
var $de1d518472a41fe9$export$87b6c6a0b160ab77 = function(episodeID) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
        var data;
        return (0, $gh3Df._)(this, function(_state) {
            data = new FormData();
            data.append('action', window.podcastComponent.ajax_action);
            data.append('episode_id', episodeID);
            return [
                2,
                fetch(window.podcastComponent.ajax_url, {
                    method: 'POST',
                    body: data
                }).then(function(res) {
                    return res.json();
                }).then(function(data) {
                    return data;
                }).catch(function(e) {
                    console.error(e);
                })
            ];
        });
    })();
};



window.itdAudioPlayers = {};
var $2934d9e99208d208$export$43bf2d15727f135d = function(player) {
    var episodeID = player.getAttribute('data-episode-id');
    var progressBar = player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).progressBar);
    var raf = null;
    // Control functions.
    var play = function() {
        if (!state.isPlaying) {
            state.isPlaying = true;
            state.audioEl.play();
            requestAnimationFrame(whilePlaying);
            player.setAttribute('data-play-state', 'play');
            updateMediaSessionAPI();
        }
    };
    var pause = function() {
        if (state.isPlaying) {
            state.isPlaying = false;
            state.audioEl.pause();
            cancelAnimationFrame(raf);
            player.setAttribute('data-play-state', 'pause');
        }
    };
    var stop = function() {
        state.audioEl.currentTime = 0;
        requestAnimationFrame(whilePlaying);
        pause();
    };
    var playFromBeginning = function() {
        state.audioEl.currentTime = 0;
        play();
    };
    // State.
    var state = {
        el: player,
        audioEl: player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).firstAudio),
        isPlaying: false,
        // Methods.
        play: play,
        pause: pause,
        stop: stop,
        playFromBeginning: playFromBeginning
    };
    // Bind state to window object.
    window.itdAudioPlayers["episode-".concat(episodeID)] = state;
    // Helper functions.
    var displayDuration = function() {
        player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).timeTotal).textContent = (0, $c46e17639d9bdc7d$export$9eabacebe6624782)(state.audioEl.duration);
    };
    var updateRangeSlider = function() {
        progressBar.max = Math.floor(state.audioEl.duration);
    };
    /**
	 * Attaching Event Handlers: Control Buttons
	 */ player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).btnPlayPause).addEventListener('click', function() {
        if (state.isPlaying) pause();
        else play();
    });
    player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).btnSkipBackward).addEventListener('click', function() {
        if (state.audioEl.currentTime > (0, $4fc5830bf026ae9f$export$2f3da36212191bc6)) {
            state.audioEl.currentTime -= (0, $4fc5830bf026ae9f$export$2f3da36212191bc6);
            requestAnimationFrame(whilePlaying);
        } else state.audioEl.currentTime = 0;
    });
    player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).btnSkipForward).addEventListener('click', function() {
        if (state.audioEl.duration - state.audioEl.currentTime > (0, $4fc5830bf026ae9f$export$2f3da36212191bc6)) {
            state.audioEl.currentTime += (0, $4fc5830bf026ae9f$export$2f3da36212191bc6);
            requestAnimationFrame(whilePlaying);
        }
    });
    // Audio.
    var whilePlaying = function() {
        progressBar.value = Math.floor(state.audioEl.currentTime);
        player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).timeCurrent).textContent = (0, $c46e17639d9bdc7d$export$9eabacebe6624782)(progressBar.value);
        player.style.setProperty('--seek-before-width', "".concat(progressBar.value / progressBar.max * 100, "%"));
        raf = requestAnimationFrame(whilePlaying);
    };
    /**
	 * Buffering
	 */ var displayBufferedAmount = function(el) {
        if (el === state.audioEl && state.audioEl.buffered.length > 0) {
            var bufferedAmount = Math.floor(state.audioEl.buffered.end(state.audioEl.buffered.length - 1));
            player.style.setProperty('--buffered-width', "".concat(bufferedAmount / progressBar.max * 100, "%"));
        }
    };
    /**
	 * Progress Bar
	 */ // Handle Range Slider Input.
    progressBar.addEventListener('input', function() {
        // Show range progress.
        player.style.setProperty('--seek-before-width', progressBar.value / progressBar.max * 100 + '%');
        // Update current time.
        player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).timeCurrent).textContent = (0, $c46e17639d9bdc7d$export$9eabacebe6624782)(progressBar.value);
        if (!state.audioEl.paused) cancelAnimationFrame(raf);
    });
    // Update audio currentTime on change.
    progressBar.addEventListener('change', function() {
        state.audioEl.currentTime = progressBar.value;
        if (!state.audioEl.paused) requestAnimationFrame(whilePlaying);
    });
    /**
	 * Playlist
	 */ if (player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).playlist)) player.querySelectorAll((0, $4fc5830bf026ae9f$export$e1252723db1c541).playlistEpisode).forEach(function(episode) {
        var associatedAudioEl = player.querySelector("#".concat(episode.getAttribute('data-target')));
        episode.addEventListener('click', function() {
            if (!episode.classList.contains((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).episodeActive)) {
                // De-select playing episode.
                player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).playlistActiveEpisode).classList.remove((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).episodeActive);
                // Select clicked episode.
                episode.classList.add((0, $4fc5830bf026ae9f$export$ce4ab0c55987d1ff).episodeActive);
                // Stop previous audio file.
                stop();
                // Load new audio element into state and reset play time.
                state.audioEl = associatedAudioEl;
                // Start new audio file.
                init();
                play();
            }
        });
        // Print episode duration.
        var printEpisodeDuration = function() {
            episode.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).playlistEpisodeDuration).textContent = "".concat((0, $c46e17639d9bdc7d$export$4a79f0068700788b)(associatedAudioEl.duration), " min");
        };
        if (associatedAudioEl.readyState > 0) printEpisodeDuration();
        else associatedAudioEl.addEventListener('loadedmetadata', printEpisodeDuration);
    });
    /**
	 * Init.
	 */ var init = function() {
        displayDuration();
        updateRangeSlider();
        displayBufferedAmount(state.audioEl);
    };
    if (state.audioEl.readyState > 0) init();
    else state.audioEl.addEventListener('loadedmetadata', init);
    player.querySelectorAll('audio').forEach(function(audioEl) {
        // Reset play state when episode has ended.
        audioEl.addEventListener('ended', function() {
            stop();
        });
        // Update buffer size.
        audioEl.addEventListener('progress', function() {
            displayBufferedAmount(audioEl);
        });
        // Disable skip forward button if episode is about to end.
        audioEl.addEventListener('timeupdate', function() {
            var skipForwardBtn = player.querySelector((0, $4fc5830bf026ae9f$export$e1252723db1c541).btnSkipForward);
            if (state.audioEl.duration - state.audioEl.currentTime <= (0, $4fc5830bf026ae9f$export$2f3da36212191bc6)) skipForwardBtn.disabled = true;
            else if (skipForwardBtn.disabled) skipForwardBtn.disabled = false;
        });
    });
    /**
	 * Media Session API
	 */ var updateMediaSessionAPI = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $dxEC4._)(function() {
            var episodeMetadata;
            return (0, $gh3Df._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!('mediaSession' in navigator)) return [
                            3,
                            4
                        ];
                        if (!state.mediaMetadata) return [
                            3,
                            1
                        ];
                        navigator.mediaSession.metadata = state.mediaMetadata;
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            (0, $de1d518472a41fe9$export$87b6c6a0b160ab77)(episodeID)
                        ];
                    case 2:
                        episodeMetadata = _state.sent();
                        if (episodeMetadata.data) {
                            state.mediaMetadata = new MediaMetadata(episodeMetadata.data);
                            navigator.mediaSession.metadata = state.mediaMetadata;
                        }
                        _state.label = 3;
                    case 3:
                        navigator.mediaSession.setActionHandler('play', play);
                        navigator.mediaSession.setActionHandler('pause', pause);
                        navigator.mediaSession.setActionHandler('seekbackward', function(details) {
                            state.audioEl.currentTime -= details.seekOffset || (0, $4fc5830bf026ae9f$export$2f3da36212191bc6);
                        });
                        navigator.mediaSession.setActionHandler('seekforward', function(details) {
                            state.audioEl.currentTime += details.seekOffset || (0, $4fc5830bf026ae9f$export$2f3da36212191bc6);
                        });
                        navigator.mediaSession.setActionHandler('seekto', function(details) {
                            if (details.fastSeek && 'fastSeek' in state.audioEl) {
                                state.audioEl.fastSeek(details.seekTime);
                                return;
                            }
                            state.audioEl.currentTime = details.seekTime;
                        });
                        navigator.mediaSession.setActionHandler('stop', stop);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
};


// TODO: Fix bug of seek slider in media session being stuck at the end.
var $72dcb31b581fb319$var$audioPlayers = document.querySelectorAll((0, $4fc5830bf026ae9f$export$e1252723db1c541).player);
$72dcb31b581fb319$var$audioPlayers.forEach(function(player) {
    // Initialize custom audio player.
    (0, $2934d9e99208d208$export$43bf2d15727f135d)(player);
    // Initialize possible external control.
    (0, $234e243fa0798158$export$e74726c334bb9cd0)(player);
});

})();
//# sourceMappingURL=podcast.min.js.map
